import Vue from 'vue';

export default {
    name: 'password-reset',
    async handle(to, from, next) {
        await Vue.state.player.ensure();

        if (!Vue.state.player.isLoggedIn()) return false;

        if (!Vue.state.player.shouldResetPassword()) {
            if (to.name === 'temporary-password-reset') {
                next('/');
                return true;
            }
            return false;
        }

        if (to.name !== 'temporary-password-reset') {
            next({ name: 'temporary-password-reset' });
            return true;
        }

        return false;
    }
};



// WEBPACK FOOTER //
// ./_common/routehandlers/password-reset.routehandler.js